import React from "react";
import { Container } from "react-bootstrap";
import { MdVerified } from "react-icons/md";

/** "No hidden fees" promise. Real text instead of a PNG so it's crisp, accessible and indexable. */
const Banner = () => (
  <section className="promo-banner" aria-label="No hidden fees guarantee">
    <Container className="promo-banner__inner">
      <span className="promo-banner__icon" aria-hidden="true">
        <MdVerified />
      </span>
      <div>
        <p className="promo-banner__title">No Hidden Fees. Guaranteed.</p>
        <p className="promo-banner__sub">The price you see is the price you pay.</p>
      </div>
    </Container>
  </section>
);

export default Banner;
